import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';

interface Option {
  label: string;
  id: number;
  value?: string;
}

interface HomeModelsGenericSelectProps {
  value: string;
  title?: string;
  disabled?: boolean;
  keyName: string;
  options: Option[];
  handleChange: (event: SelectChangeEvent, keyToUpdate: string) => void;
}

export const HomeModelsGenericSelect = ({
  value,
  title,
  disabled,
  keyName,
  options,
  handleChange,
}: HomeModelsGenericSelectProps) => {
  return (
    <FormControl
      sx={{ width: '11%' }}
      className="home-generic-select"
      size="small"
    >
      {!value && (
        <InputLabel id="lot-status-label">
          {title || 'Select an option'}
        </InputLabel>
      )}
      <Select
        disabled={disabled}
        data-lot-status-dropdown
        labelId="lot-status-label"
        variant="filled"
        value={value}
        name={keyName}
        onChange={(event) => handleChange(event, keyName)}
      >
        <MenuItem value="0">
          <em>None</em>
        </MenuItem>
        {options.map((el, index) => (
          <MenuItem value={el.value} key={index}>
            {el.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
